export type SelectMultiListDisplayMode = 'unlimited' | 'singleRow' | 'multiRow'

export const getDisplayMode = (
  maxVisibleChips?: number,
  maxChipsHeight?: number
): SelectMultiListDisplayMode => {
  if (maxVisibleChips && maxChipsHeight) return 'multiRow'
  if (maxVisibleChips) return 'singleRow'
  return 'unlimited'
}
